__turbopack_context__.v({
  "container": "RestaurantIntroSection-module__C6gYBq__container",
  "dot": "RestaurantIntroSection-module__C6gYBq__dot",
  "eyebrow": "RestaurantIntroSection-module__C6gYBq__eyebrow",
  "feature": "RestaurantIntroSection-module__C6gYBq__feature",
  "featureList": "RestaurantIntroSection-module__C6gYBq__featureList",
  "imageDuo": "RestaurantIntroSection-module__C6gYBq__imageDuo",
  "largeImage": "RestaurantIntroSection-module__C6gYBq__largeImage",
  "section": "RestaurantIntroSection-module__C6gYBq__section",
  "smallImage": "RestaurantIntroSection-module__C6gYBq__smallImage",
  "text": "RestaurantIntroSection-module__C6gYBq__text",
  "title": "RestaurantIntroSection-module__C6gYBq__title",
});
